import { useEffect } from "react";
import { Input, Radio } from "@gamesb42/ui-kit";

import { corparateDoc } from "./index";
import { observer } from "mobx-react";
import TextArea from "../TextArea";
import UploadFile from "components/UploadFile";

import { ReactComponent as Pdf } from "./assets/pdf.svg";
import { ReactComponent as Close } from "./assets/close.svg";

import s from "./styles.module.scss";
import { authorizedRequest } from "utils/authorization";
import FileName from "./components/FileName";

const Step6 = observer(() => {
  useEffect(() => {
    const conditionForUpload =
      corparateDoc.values.step6Variant === "upload" &&
      corparateDoc.values.memorandumAndArticlesOfAssociationFile!.name.length >
        0;
    const conditionForNotApplicable =
      corparateDoc.values.step6Variant === "notApplicable" &&
      corparateDoc.values.memorandumAndArticlesOfAssociationComment.length > 0;

    if (conditionForUpload || conditionForNotApplicable) {
      corparateDoc.isStepIsValid[6] = true;
    } else {
      corparateDoc.isStepIsValid[6] = false;
    }
  }, [
    corparateDoc.values.step6Variant,
    corparateDoc.values.memorandumAndArticlesOfAssociationComment,
    corparateDoc.values.memorandumAndArticlesOfAssociationFile!.name,
  ]);

  function delFileHandler() {
    if (
      corparateDoc.values.memorandumAndArticlesOfAssociationFile?.docId
        ?.length > 0
    ) {
      corparateDoc.values.needtoDelete.push(
        corparateDoc.values.memorandumAndArticlesOfAssociationFile.docId
      );
    }

    corparateDoc.values.memorandumAndArticlesOfAssociationFile = {
      id: "",
      docId: "",
      name: "",
      value: "",
      size: 0,
    };

    corparateDoc.values.memorandumAndArticlesOfAssociationComment = "";
  }

  return (
    <>
      <p>Memorandum and Articles of Association*</p>
      <Radio.Group value={corparateDoc.values.step6Variant}>
        <Radio
          value="upload"
          onChange={() => {
            delFileHandler();
            corparateDoc.values.step6Variant = "upload";
          }}
        >
          Upload
        </Radio>
        <Radio
          value="notApplicable"
          onChange={() => {
            delFileHandler();
            corparateDoc.values.step6Variant = "notApplicable";
          }}
        >
          Not applicable
        </Radio>
      </Radio.Group>

      {corparateDoc.values.step6Variant === "upload" && (
        <div
          style={{
            marginTop: "32px",
            display: "flex",
            flexDirection: "column",
            gap: "32px",
          }}
        >
          <div className={s.uploadHolder}>
            {(corparateDoc.values.memorandumAndArticlesOfAssociationFile!
              .size === 0 && (
              <UploadFile
                dragText="Drag and drop file*"
                uploadText={`50 Mb max. weight`}
                onUpload={(e, file) => {
                  corparateDoc.values.memorandumAndArticlesOfAssociationFile!.name =
                    file.name;
                  corparateDoc.values.memorandumAndArticlesOfAssociationFile!.size =
                    file.size;
                  corparateDoc.values.memorandumAndArticlesOfAssociationFile!.value =
                    file;
                }}
              />
            )) || (
              <FileName
                fileName="memorandumAndArticlesOfAssociationFile"
                clearFiles={delFileHandler}
              />
            )}
          </div>
          <Input.TextArea
            style={{ height: "100px" }}
            label="Comment to the uploaded file"
            disabled={
              corparateDoc.values.memorandumAndArticlesOfAssociationFile?.docId
                ?.length > 0
            }
            showCount={true}
            maxLength={200}
            value={
              corparateDoc.values.memorandumAndArticlesOfAssociationComment
            }
            onChange={(e) => {
              corparateDoc.values.memorandumAndArticlesOfAssociationComment =
                e.target.value;
            }}
          />
        </div>
      )}

      {corparateDoc.values.step6Variant === "notApplicable" && (
        <div style={{ padding: "32px 0 0 0" }}>
          <Input.TextArea
            style={{ height: "100px" }}
            label="Not applicable? Please explain why*"
            disabled={false}
            showCount={true}
            maxLength={200}
            value={
              corparateDoc.values.memorandumAndArticlesOfAssociationComment
            }
            onChange={(e) => {
              corparateDoc.values.memorandumAndArticlesOfAssociationComment =
                e.target.value;
            }}
            placeholder="Not applicable? Please explain why*"
          />
        </div>
      )}
    </>
  );
});

export default Step6;
